angular
	.module 'App.Component'
	.component 'integrationRun',
		{
			templateUrl: '@component/integration-run/integration-run.view.html'
			controller: 'IntegrationRunComponent'
			controllerAs: 'integrationRun'
			bindings:
				datePicker: '<?'
				descriptionText: '@?'
				disabled: '<?'
				isSplitByDaysEnabled: '<?'
				onRunClick: '&'
		}

class IntegrationRunComponent extends AbstractController
	@inject 'DateService'
	@registerController()

	initialize: ->
		@disabled ?= false
		@isSplitByDaysEnabled ?= true
		@splitByDays = false
		@datePicker ?=
			maxDate: moment()

	onClickCallback: ->
		@onRunClick({
			timestampFrom: @datePicker.startDate
			timestampTo: @datePicker.endDate
			# send user timezone to get integration file name dates formatted correctly in backend
			timeZone: @DateService.getTimezone()
			splitByDays: @splitByDays
		})
